import React from 'react';
import { StyleSheet } from 'react-native';
import { Button, theme } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

/**
 * This is *not* the pay with Apple Pay button.
 * Instead it is a button that triggers the Apple Pay payment sheet.
 * The card will be captured and processed in the backend, not in the frontend.
 */
export const ApplePayCheckoutButton = (props: ApplePayCheckoutButtonProps) => {
  const { isLoading, onPress } = props;

  const { t } = useLocalizationContext();
  const checkoutApplePay = t('checkout.place-order.apple-pay');

  return (
    <Button
      style={styles.applePayButton}
      palette="black"
      size="large"
      isLoading={isLoading}
      accessibilityLabel={checkoutApplePay}
      onPress={onPress}
    >
      {checkoutApplePay}
    </Button>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  applePayButton: {
    borderRadius: theme.radius.medium,
    marginHorizontal: theme.spacing['2'],
    marginVertical: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ApplePayCheckoutButtonProps = {
  isLoading?: boolean;
  onPress?: () => void;
};
